import { BuildingType, RefDataType } from 'scenes/common/types';
import { HomeFunnelState } from 'scenes/home/flows/types';
import { getBuildingType, getRiskAddress } from 'scenes/home/selectors';

import { WirePropertyData } from '../types';

const toTypeOfBuilding = (
  buildingType: BuildingType,
  buildingTypes: RefDataType[]
) =>
  buildingTypes.find(({ value }) => value === buildingType)?.label ||
  buildingType;

export const toWireProperty = (
  state: HomeFunnelState,
  buildingTypes: RefDataType[]
): WirePropertyData => {
  const { postcode } = getRiskAddress(state);
  return {
    typeOfBuilding: toTypeOfBuilding(getBuildingType(state), buildingTypes),
    riskPostcode: postcode,
  };
};
